<template>
    <div class="org_settings user-settings mb-5">
        <div class="row g-4">
            <div :class="canView('insights') && showInsightSettings ? 'col-lg-8 col-12' : 'col-12'">
                <div class="row g-3">
                    <div class="col">
                        <div class="card mx-1">
                            <div class="card-body">
                                <edit-user :user="user" :client="client" />
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-12">
                        <div class="card mx-1">
                            <div class="card-body">
                                <notification-settings :client="client" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="canEdit('scorecard') && showScorecardFilter">
                        <div class="card mx-1">
                            <div class="card-body">
                                <scorecard-filter :client="client" @data-blend-loaded="handleDataBlendLoaded" />
                            </div>
                        </div>
                    </div>


                    <div class="col-xl-8 col-12" v-if="canView('insights') && showInsightSettings">
                        <div class="card mx-1">
                            <div class="card-body">
                                <insight-preferences :user="user" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-12" v-if="canView('insights') && showInsightSettings">
                <div class="card mx-1 mb-3">
                    <div class="card-body">
                        <prioritization-settings :client="client" @prioritization-loaded="handlePrioritizationLoaded" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import permissionsMixin from '../../../mixins/permissions';
import InsightPreferences from './InsightPreferences.vue';

export default defineComponent({
    mixins: [permissionsMixin],
    name: 'UserSettings',
    components: {
        InsightPreferences
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showScorecardFilter: true, // Default to true, will be updated when data loads
            showInsightSettings: true // Default to true, will be updated when data loads
        };
    },
    beforeMount() {

    },
    methods: {
        handleDataBlendLoaded(hasDataBlend) {
            this.showScorecardFilter = hasDataBlend;
        },
        handlePrioritizationLoaded(hasPrioritization) {
            this.showInsightSettings = hasPrioritization;
        }
    }
});
</script>
